import React           from 'react';
import handleReduceTen from 'functions/droppable/handleReduceTen';
import sizes           from 'utils/sizes';

import { makeStyles  } from "makeStyles";


const useStyles = makeStyles()(
    (theme) => ({
    button: {
      width:          40,
      height:         30,
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'center',
      color:          theme.blue,
      background:     '#FFF',
      borderRadius:   '0.4em',
      top:            0,
      cursor:         'pointer',
      border:         `1px solid ${ theme.blue }`,
      boxShadow:      '2px 3px 4px rgba(0,0,0,0.1)',
      transition:     'transform 0.3s',
      fontWeight:     'bold',
      '&:hover': {
        background: '#EEF'
      }
    }
  })
);

type ButtonProps = {
  variant:     string;
  value:       number;
  wideScreen:  boolean;
}

const Button: React.FC<ButtonProps> = ({ 
    variant,
    value,
    wideScreen
}) => {

  const { classes } = useStyles();


  const buttonStyle = React.useMemo(() => {
      const { bigBoxGap, smallBoxGap } = sizes;
      const gap = wideScreen ? bigBoxGap : smallBoxGap;

      return{
          transform: variant === 'mazeget' ? 'none' : `translate(0px, ${ -(((value - 1) * gap) / 2) +40 }px)`,
          left:      variant === 'input' ? -70 : -40,
          position:  variant === 'mazeget' ? undefined : 'absolute' as undefined | 'absolute'
        }
  },[value, variant, wideScreen])

  

  return (
    <div 
       className = { classes.button }
       style     = { buttonStyle }
       onClick   = { () => {
         if (variant === 'mazeget'){ return } 
         handleReduceTen();
      }}
    >
      -10
    </div>
          
  );
}

export default Button;
/* 

const mapStateToProps = (reducer: reducerType) => {
  return {
}};
  
export default connect(mapStateToProps)(Button);
  
  
  
  
  
  
   */